var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-end": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("AdministrationAddUserDetailDialog.addTitleMsg")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.clearForm()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { "pa-5": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Username",
                                  rules: _vm.nameRules,
                                },
                                model: {
                                  value: _vm.username,
                                  callback: function ($$v) {
                                    _vm.username = $$v
                                  },
                                  expression: "username",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "Password",
                                  rules: _vm.passwordRules,
                                  type: "password",
                                },
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "Confirm Password",
                                  rules: _vm.comfirmRules,
                                  type: "password",
                                },
                                model: {
                                  value: _vm.confirmPassword,
                                  callback: function ($$v) {
                                    _vm.confirmPassword = $$v
                                  },
                                  expression: "confirmPassword",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  label: "Email",
                                  rules: _vm.emailRules,
                                },
                                model: {
                                  value: _vm.email,
                                  callback: function ($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Tenant",
                                  items: _vm.activeTenantNames,
                                  rules: [(v) => !!v || "Tenant is required"],
                                  required: "",
                                },
                                model: {
                                  value: _vm.userRole,
                                  callback: function ($$v) {
                                    _vm.userRole = $$v
                                  },
                                  expression: "userRole",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Is System Administrator" },
                                model: {
                                  value: _vm.isSysAdmin,
                                  callback: function ($$v) {
                                    _vm.isSysAdmin = $$v
                                  },
                                  expression: "isSysAdmin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                attrs: { label: "Is Tenant Administrator" },
                                model: {
                                  value: _vm.isTenantAdmin,
                                  callback: function ($$v) {
                                    _vm.isTenantAdmin = $$v
                                  },
                                  expression: "isTenantAdmin",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-switch", {
                                attrs: {
                                  label: "Enable Two factor authentication",
                                },
                                model: {
                                  value: _vm.enableTwoFactor,
                                  callback: function ($$v) {
                                    _vm.enableTwoFactor = $$v
                                  },
                                  expression: "enableTwoFactor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("done")]),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("Button.Create")) +
                              "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }